<template>
    <div>
      <Head title="Tasas de cambio" />
      
      <app-toolbar name="Tasa de cambio" namePlural="Tasa de cambios" createHref="/taxes/create" :hiddenCreate="false" :exportButtons="false" />

      <div class="bg-white rounded-md shadow overflow-x-auto">
        <table class="w-full whitespace-nowrap">
          <tr class="text-center font-bold">
            <th class="p-3">ID</th>
            <th class="p-3">Cambio</th>
            <th class="p-3">Fecha</th>
          </tr>
          <tr v-for="change in changes.data" :key="change.id" class="hover:bg-gray-100 focus-within:bg-gray-100 text-center">
            <td class="p-3">
              <Link class="p-3 focus:text-indigo-500">
                {{ change.id }}
              </Link>
            </td>
            <td class="p-3">
              <Link class="p-3 focus:text-indigo-500">
                {{ change.change }}
              </Link>
            </td>
            <td class="p-3">
              <Link class="p-3 focus:text-indigo-500">
                {{ formatDate(change.created_at) }}
              </Link>
            </td>
          </tr>
          <tr v-if="!changes">
            <td class="p-3 border-t" colspan="4">No hay tasas de cambio.</td>
          </tr>
        </table>
      </div>
      <!-- <pagination class="mt-6" :links="vendors.links" /> -->
    </div>
  </template>
  
  <script>
  import { Head, Link } from '@inertiajs/inertia-vue3'
  import Icon from '@/Shared/Icon'
  import Layout from '@/Shared/Layout'
  import AppToolbar from '../../Shared/AppToolbar.vue'
  
  export default {
    components: {
      Head,
      Icon,
      Link,
      AppToolbar
    },
    layout: Layout,
    props: {
      changes: Object
    },
    methods: {
      formatDate(isoString) {
        return isoString.split('T')[0].split('-').reverse().join('/');
      },
    }
  }
  </script>
  